import React from 'react'
import { SVGProps } from 'react'

const KeyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={48}
    height={48}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path d="M43.4763 4.52358C37.4448 -1.50792 27.6313 -1.50783 21.5998 4.52367C17.48 8.64352 16.049 14.7149 17.8328 20.2231L0.412031 37.644C0.148313 37.9078 0 38.2648 0 38.6384V46.5938C0 47.3711 0.628969 48 1.40625 48H9.36169C9.73519 48 10.0923 47.8517 10.3559 47.588L12.3444 45.5981C12.6479 45.2946 12.7962 44.8689 12.7468 44.4418L12.4996 42.3049L15.4604 42.0261C16.1333 41.9629 16.6648 41.4314 16.728 40.7585L17.0068 37.7977L19.1437 38.0462C19.5405 38.0998 19.9402 37.9665 20.2409 37.7002C20.5403 37.4325 20.7119 37.0506 20.7119 36.6496V34.0313H23.2827C23.6562 34.0313 24.0133 33.883 24.2769 33.6193L27.8832 30.0607C33.3901 31.846 39.3564 30.5228 43.4763 26.4001C49.5078 20.3687 49.5078 10.5551 43.4763 4.52358ZM39.498 14.4676C37.8528 16.1129 35.1776 16.1129 33.5324 14.4676C31.8872 12.8224 31.8872 10.1473 33.5324 8.50205C35.1776 6.85683 37.8528 6.85683 39.498 8.50205C41.1432 10.1473 41.1431 12.8224 39.498 14.4676Z" />
    </g>
  </svg>
)
export default KeyIcon
